import FacebookIcon from '@components/v2/icons/Facebook';
import InstagramIcon from '@components/v2/icons/Instagram';
import PinterestIcon from '@components/v2/icons/Pinterest';
import TwitterIcon from '@components/v2/icons/Twitter';
import YoutubeIcon from '@components/v2/icons/Youtube';
import { SocialMediaFieldConfig } from './socialMediaField.types';

export const SOCIAL_MEDIA_FIELDS: SocialMediaFieldConfig[] = [
  {
    name: 'instagramUrl',
    label: 'instagram',
    urlPrefix: 'instagram.com/',
    icon: InstagramIcon,
  },
  {
    name: 'facebookUrl',
    label: 'facebook',
    urlPrefix: 'facebook.com/',
    icon: FacebookIcon,
  },
  {
    name: 'twitterUrl',
    label: 'twitter',
    urlPrefix: 'twitter.com/',
    icon: TwitterIcon,
  },
  {
    name: 'pinterestUrl',
    label: 'pinterest',
    urlPrefix: 'pinterest.com/',
    icon: PinterestIcon,
  },
  {
    name: 'youtubeUrl',
    label: 'youtube',
    urlPrefix: 'youtube.com/',
    icon: YoutubeIcon,
  },
];
